import { getRegisterFunction } from '../../utils/register.js';
import { OneUxDialogElement } from './OneUxDialogElement.js';
export const register = getRegisterFunction(OneUxDialogElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-dialog': OneUxDialogElement;
    "dialog-f5a2631f687530812ead315cb53a27e2": OneUxDialogElement;
  }
}